/**
 * basic.operatingUnitFlag(基本情報 > ２つ以上のユニットを運用している)が有効な時表示
 * UnitsFieldsと連動してユニットごとの大規模住居等減算の管理を行う
 */

import * as React from "react";
import { WithStyles, withStyles, createStyles } from "@material-ui/core";
import { StyleRules } from "@material-ui/core/styles";
import { FormikProps, FieldArray } from "formik";
import { FacilityValues } from "@initialize/mgr/GroupHome/facility/initialValues";
import ReadonlyTextField from "@components/molecules/ReadonlyTextField";
import FormikSelect from "@components/molecules/FormikSelect";
import { SUBTRACTION_OF_LARGE_SCALE_HOUSING } from "@constants/mgr/GroupHome/variables";
import deepEqual from "fast-deep-equal";

const styles = (): StyleRules =>
  createStyles({
    label: {
      display: "flex",
      fontSize: 12,
      color: "#37474F",
      "& > :nth-child(1)": {
        width: 478,
        marginRight: 16
      },
      "& > :nth-child(2)": {
        width: 280,
        marginRight: 16
      },
      "& > :nth-child(3)": {
        width: 158
      }
    },
    field: {
      display: "flex",
      "& > div": {
        marginBottom: 16
      },
      "& > :nth-child(1)": {
        width: 478,
        marginRight: 16
      },
      "& > :nth-child(2)": {
        width: 280
      },
      "& > :nth-child(3)": {
        width: 158
      },
      "&:first-child": {
        "& label": {
          color: "inherit"
        }
      },
      "&:not(:first-child)": {
        "& > :nth-child(2)": {
          marginTop: -16
        }
      }
    }
  });

type OwnProps = {
  formikProps: FormikProps<FacilityValues>;
};
type Props = OwnProps & WithStyles<typeof styles>;

const UnitsLargeScaleHousingFieldsCore = (props: Props): JSX.Element => {
  const { units } = props.formikProps.values;
  return (
    <FieldArray name="units">
      {(): JSX.Element => (
        <div>
          <div className={props.classes.label}>
            <div>ユニット名</div>
            <div>大規模住居等減算</div>
          </div>
          {units.map((unit, i) => {
            // 削除フラグがあれば描画しない
            if (unit.is_deleted) {
              return null;
            }
            return (
              <div
                className={props.classes.field}
                key={`unitLargeScaleHousing-${unit.id || `index-${i}`}`}
              >
                <ReadonlyTextField
                  value={unit.unit_name}
                  defaultValue=""
                  placeholder="ユニット名"
                />
                <FormikSelect
                  label=""
                  name={`units[${i}].subtraction_of_large_scale_housing_type`}
                  options={SUBTRACTION_OF_LARGE_SCALE_HOUSING}
                />
              </div>
            );
          })}
        </div>
      )}
    </FieldArray>
  );
};

export const UnitsLargeScaleHousingFields = React.memo(
  withStyles(styles)(UnitsLargeScaleHousingFieldsCore),
  (prev, next) =>
    deepEqual(prev.formikProps.values.units, next.formikProps.values.units)
);
